<template>
  <div class="product-show-modular">
    <div class="header-modualr">
      <img
        class="header-bg-img"
        src="../assets/product/banner-bg-img.png"
        alt=""
      />
      <div class="left-item">
        <div style="position: relative">
          <img
            class="start-icon-1"
            src="../assets/product/banner-star-icon1.png"
            alt=""
          />
          <img
            class="start-icon-2"
            src="../assets/product/banner-star-icon2.png"
            alt=""
          />
          <span class="header-title">{{
            $t("translateText.ourproductsText")
          }}</span>
        </div>
      </div>
    </div>
    <div class="body-modular">
      <div style="margin: 20px 0">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{currLanguage==3?"Home":"首页"}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{currLanguage==3?"Product series":"产品系列"}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row :gutter="20">
        <el-col :span="24" :xs="24">
          <div class="right-item-modualr">
            <div class="pagination-top-modular">
              <el-row class="pagination-top-modular-el-row">
                <el-col :span="18" :xs="24">
                  <el-row style="width: 100%">
                    <el-col :span="16" :xs="24">
                      <el-menu
                        :default-active="activeIndex"
                        class="el-menu-demo"
                        mode="horizontal"
                        @select="handleSelect"
                      >
                        <el-menu-item index="1">{{
                          $t("translateText.recommendtarText")
                        }}</el-menu-item>
                        <el-menu-item index="2">{{
                          $t("translateText.newText")
                        }}</el-menu-item>
                        <el-menu-item index="3">
                          {{ $t("translateText.salesvolumetarText") }}
                          <img
                            v-if="salesFlag == 0"
                            class="sales-order-by-icon"
                            src="../assets/product/order-by-icon.png"
                            alt=""
                          />
                          <img
                            v-else-if="salesFlag == 1"
                            class="sales-order-by-icon"
                            src="../assets/product/order-by-asc.png"
                            alt=""
                          />
                          <img
                            v-else-if="salesFlag == 2"
                            class="sales-order-by-icon"
                            src="../assets/product/order-by-dasc.png"
                            alt=""
                          />
                        </el-menu-item>
                        <el-menu-item index="4">
                          {{ $t("translateText.appraiseText") }}
                          <img
                            v-if="evaluateFlag == 0"
                            class="sales-order-by-icon"
                            src="../assets/product/order-by-icon.png"
                            alt=""
                          />
                          <img
                            v-else-if="evaluateFlag == 1"
                            class="sales-order-by-icon"
                            src="../assets/product/order-by-asc.png"
                            alt=""
                          />
                          <img
                            v-else-if="evaluateFlag == 2"
                            class="sales-order-by-icon"
                            src="../assets/product/order-by-dasc.png"
                            alt=""
                          />
                        </el-menu-item>
                        <el-menu-item index="5">
                          {{ $t("translateText.pricetarText") }}
                          <img
                            v-if="priceFlag == 0"
                            class="sales-order-by-icon"
                            src="../assets/product/order-by-icon.png"
                            alt=""
                          />
                          <img
                            v-else-if="priceFlag == 1"
                            class="sales-order-by-icon"
                            src="../assets/product/order-by-asc.png"
                            alt=""
                          />
                          <img
                            v-else-if="priceFlag == 2"
                            class="sales-order-by-icon"
                            src="../assets/product/order-by-dasc.png"
                            alt=""
                          />
                        </el-menu-item>
                      </el-menu>
                    </el-col>
                    <el-col :span="8" :xs="24">
                      <div class="price-section-modular">
                        <el-input
                          class="price-item price-start-item"
                          v-model="priceStart"
                          placeholder="$"
                        ></el-input>
                        <div class="price-line"><span></span></div>
                        <el-input
                          class="price-item price-end-item"
                          v-model="priceEnd"
                          placeholder="$"
                        ></el-input>
                        <div class="search-go-btn">
                          <el-button plain @click="getProductList(1)"
                            >GO</el-button
                          >
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="6" :xs="24">
                  <div class="pagination-item">
                    <div>
                      <span class="pagination-curr">{{ page }}</span
                      >/<span class="pagination-all">{{
                        Math.ceil(pageCount / pagesize)
                      }}</span>
                    </div>
                    <div class="pagination-item-modualr">
                      <div
                        class="pagination-left-item"
                        @click="changeCurrpage(false)"
                      >
                        <img
                          v-if="currpage == 1"
                          src="../assets/product/pagination-left-icon-1.png"
                          alt=""
                        />
                        <img
                          v-else
                          src="../assets/product/pagination-left-icon-2.png"
                          alt=""
                        />
                      </div>
                      <div
                        class="pagination-right-item"
                        @click="changeCurrpage(true)"
                      >
                        <img
                          v-if="currpage == totalPage"
                          src="../assets/product/pagination-right-icon-1.png"
                          alt=""
                        />
                        <img
                          v-else
                          src="../assets/product/pagination-right-icon-2.png"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="commodity-show-modular" v-loading="productLoading">
              <div
                v-if="produceListData.length == 0"
                class="my-evaluate-bodu-none"
              >
                <img
                  class="none-icon"
                  src="../assets/public/none-icon.png"
                  alt=""
                />
                <p class="none-title">{{ $t("translateText.NoDataText") }}</p>
              </div>
              <div
                v-else
                class="commodity-show-item-modualr"
                v-for="(item, index) in produceListData"
                :key="index"
              >
                <div class="commodity-show-item">
                  <div class="commodity-show-item-img">
                    <img
                      class="commodity-show-img"
                      @click="toProductDetail(item.id)"
                      :src="item.cover"
                      alt=""
                    />
                  </div>
                  <div class="commodity-show-item-msg">
                    <div class="commodity-show-item-price">
                      {{ currencySymbol
                      }}{{
                        item.has_discount == 1
                          ? item.discount_price
                          : item.price
                      }}
                      <span
                        class="commodity-show-item-discpunt-price"
                        v-if="item.has_discount == 1"
                      >
                        {{ currencySymbol }}{{ item.price }}
                      </span>
                    </div>
                    <div
                      class="commodity-show-item-introduce"
                      @click="toProductDetail(item.id)"
                    >
                      {{ currLanguage == 3 ? item.eng_title : item.title }}
                    </div>
                    <div class="commodity-show-item-evaluate">
                      <div class="commodity-evaluate">
                        <!-- <span class="commodity-evaluate-num">{{
                          item.comment_num
                        }}</span>
                        <span class="commodity-evaluate-title">{{
                          $t("translateText.appraiseText")
                        }}</span> -->
                      </div>
                      <div class="commodity-coupon" v-if="item.has_coupon == 1">
                        {{ $t("translateText.certificate") }}
                      </div>
                    </div>
                    <div class="commodity-show-item-operation">
                      <div class="commodity-shop-cart" @click="toProductDetail(item.id)">
                        <span
                          class="add-cart-title"
                          >{{ $t("translateText.productDetailsText") }}</span
                        >
                      </div>
                    </div>
                    <div class="commodity-show-item-operation">
                      <!-- <div
                        class="commodity-collection"
                        @click="
                          productaddCollect(item.id, item.is_collect, index)
                        "
                      >
                        <img
                          class="collection-icon"
                          v-if="item.is_collect == 1"
                          src="../assets/home/collection-icon-2.png"
                          alt=""
                        />
                        <img
                          class="collection-icon"
                          v-else
                          src="../assets/home/collection-icon.png"
                          alt=""
                        />
                        <span class="collection-title">{{
                          $t("translateText.collectText")
                        }}</span>
                      </div> -->
                      <div class="commodity-shop-cart shop-cart-color" @click="productAddCart(item.id, item.number, 1, '', 1)">
                        <!-- <img
                          class="shop-cart-icon"
                          src="../assets/home/shop-cart-icon.png"
                          alt=""
                        /> -->
                        <span
                          class="add-cart-title"
                        >
                          {{ $t("translateText.addCartText") }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="pagination-footer-modualr">
              <el-pagination
                :page-size="pagesize"
                :current-page="page"
                background
                layout="prev, pager, next"
                :total="pageCount"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      productLoading: false, //loding
      currLanguage: 1, //当前语言
      salesFlag: 0, //销量
      evaluateFlag: 0, //评价
      priceFlag: 0, //价格
      priceStart: "",
      priceEnd: "",
      currpage: 1,
      totalPage: 1,
      page: 1,
      pagesize: 15,
      pageCount: 1,
      produceListData: [], //产品列表
      currProductType: 1, //当前分类id
      currProductTypeId: 0, //0默认全部
      activeProductTypeId: 0, //商品分类-active
      activeIndex: "1", //产品类别header
      treeMenuList: [], //产品分类
      searchKey: "", //搜索的关键词
      currencySymbol:
        localStorage.getItem("currencySymbol") == null
          ? "$"
          : localStorage.getItem("currencySymbol"),
      pageText: {
        ourproductsText: "我们的产品",
        productcategoryText: "产品类别",
        recommendtarText: "推荐",
        newText: "新品",
        salesvolumetarText: "销量",
        pricetarText: "价格",
        NoDataText: "暂无数据",
        drawbtnText: "领取",
        appraiseText: "评价",
        certificateText: "券",
        collectText: "收藏",
        addCartText: "加入购物车",
        universalText: "全场通用",
        useText: "使用",
        limitText: "限",
        fullText: "满",
        subtractText: "减",
      },
    };
  },
  methods: {
    /**
     * 产品类别点击
     * @param {*} index
     * @param {*} id
     */
    openNextLevel(index, id) {
      let that = this;
      let netData = that.treeMenuList[index];
      netData.level1.flag = !netData.level1.flag;
      that.$set(that.treeMenuList, index, netData);
      // 选中的产品-id
      that.activeProductTypeId = id;
    },

    /**
     * 排序点击
     * @param {*} key
     * @param {*} keyPath
     */
    handleSelect(key, keyPath) {
      let that = this;
      // 1推荐2新品3销量(正序)4销量(倒序)5评价正6评价倒序7价格正序8价格倒序
      switch (parseInt(key)) {
        case 1:
          // 1推荐
          that.getProductList(1);
          break;
        case 2:
          // 2新品
          that.getProductList(2);
          break;
        case 3:
          // 销量 3销量(正序)4销量(倒序)
          that.evaluateFlag = 0; //评价
          that.priceFlag = 0; //价格
          if (that.salesFlag == 2) {
            that.salesFlag = 0;
            that.getProductList(3);
          } else {
            that.salesFlag++;
            if (that.salesFlag == 1) {
              that.getProductList(3);
            } else if (that.salesFlag == 2) {
              that.getProductList(4);
            }
          }
          break;
        case 4:
          // 评价 5评价正6评价倒序
          that.salesFlag = 0; //销量
          that.priceFlag = 0; //价格
          if (that.evaluateFlag == 2) {
            that.evaluateFlag = 0;
            that.getProductList(5);
          } else {
            that.evaluateFlag++;
            if (that.evaluateFlag == 1) {
              that.getProductList(5);
            } else if (that.evaluateFlag == 2) {
              that.getProductList(6);
            }
          }
          break;
        case 5:
          // 价格  7价格正序8价格倒序
          that.salesFlag = 0; //销量
          that.evaluateFlag = 0; //评价
          if (that.priceFlag == 2) {
            that.priceFlag = 0;
            console.log("that.priceFlag",that.priceFlag);
            that.getProductList(7);
          } else {
            that.priceFlag++;
            if (that.priceFlag == 1) {
              that.getProductList(7);
            } else if (that.priceFlag == 2) {
              that.getProductList(8);
            }
          }
          break;

        default:
          that.salesFlag = 0;
          that.evaluateFlag = 0;
          that.priceFlag = 0;
          break;
      }
    },

    /**
     * 顶部翻页
     * @param {*} type
     */
    changeCurrpage(type) {
      let that = this;
      that.productLoading = true;
      if (type) {
        if (that.currpage == that.totalPage) {
          that.currpage = that.totalPage;
        } else {
          that.currpage++;
        }
      } else {
        if (that.currpage == 1) {
          that.currpage = 1;
        } else {
          that.currpage--;
        }
      }
      that.page = that.currpage;
      that.getProductList(that.currProductType);
    },

    /**
     * 分页点击
     * @param {*} val
     */
    handleCurrentChange(val) {
      let that = this;
      that.page = val;
      that.getProductList(that.currProductType);
    },

    /**
     * 跳转-详情
     * @param {*} id
     */
    toProductDetail(id) {
      this.$router.push({
        path: "/productDetail",
        query: { product_id: id },
      });
    },

    /**
     * 商品分类
     */
    getCategoryList() {
      let that = this;
      let data = {
        page: 1,
        pagesize: 1000,
      };
      this.$http.getCategoryList(
        data,
        (res) => {
          if (res.ret == 1) {
            res.data.forEach((v, i) => {
              that.treeMenuList.push({
                level1: {
                  flag: false,
                  id: v.id,
                  name: v.name,
                  eng_name: v.eng_name,
                  children: [],
                },
              });
              if (v.children != undefined && v.children.length > 0) {
                v.children.forEach((v2, i2) => {
                  that.treeMenuList[i].level1.children.push({
                    id: v2.id,
                    parentid: v2.parentid,
                    name: v2.name,
                    eng_name: v2.eng_name,
                  });
                });
              }
            });
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 根据类型获取商品
     * @param {*} index
     * @param {*} id
     */
    searchProductByType(index, id) {
      let that = this;
      index = parseInt(index);
      // 产品类型ID
      that.currProductTypeId = id;
      // 商品分类-active
      if (index == 0) {
        // 全部的时候
        that.activeProductTypeId = 0;
      }
      let netData = that.treeMenuList[index];
      netData.level1.flag = !netData.level1.flag;
      that.$set(that.treeMenuList, index, netData);
      that.searchKey = "";
      that.getProductList(that.currProductType);
    },

    /**
     * 产品列表
     * @param {*} type
     */
    getProductList(type) {
      let that = this;
      that.currProductType = type;
      let data = {
        page: that.page,
        pagesize: that.pagesize,
        key: that.searchKey, //搜索值
        typeid: that.currProductTypeId, //分类id
        type: type, //1推荐2新品3销量(正序)4销量(倒序)5评价正6评价倒序7价格正序8价格倒序
        start_price: that.priceStart, //开始价格
        end_price: that.priceEnd, //结束价格
        exchange_rate: localStorage.getItem("currencyRate"), //汇率值
      };
      // console.log('data---',data);
      // return
      this.$http.getProductList(
        data,
        (res) => {
          if (res.ret == 1) {
            that.produceListData = res.data;
            // console.log('that.produceListData',that.produceListData);
            that.pageCount = parseInt(res.total);
            that.totalPage = Math.ceil(that.pageCount / that.pagesize);
            that.productLoading = false;
          } else {
            that.produceListData = [];
            // this.$message.error(res.msg);
            that.productLoading = false;
          }
        },
        (res) => {
          that.productLoading = false;
          that.produceListData = [];
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 商品加入购物车
     * @param {*} product_id
     * @param {*} sku_number
     * @param {*} type
     * @param {*} portfolio_sales_middle_id
     * @param {*} cartNum
     */
    productAddCart(
      product_id,
      sku_number,
      type,
      portfolio_sales_middle_id,
      cartNum
    ) {
      let that = this;
      // if (this.$parent.tipsLogin()) return;
      that.$parent.addCart(
        product_id,
        sku_number,
        type,
        portfolio_sales_middle_id,
        cartNum
      );
    },

    /**
     *   加入收藏 取消收藏
     * @param {*} id
     * @param {*} status
     * @param {*} index
     */
    productaddCollect(id, status, index) {
      let that = this;
      if (this.$parent.tipsLogin()) return;
      that.$parent.productCollect(
        id,
        status,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(res.msg);
            // 设置收藏
            let newData = that.produceListData[index];
            newData.is_collect = !status;
            this.$set(that.produceListData, index, newData);
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          this.$message.error(res.msg);
        }
      );
    },
    /**
     * 获取页面参数
     */
    getProductTypeByUrl() {
      let that = this;
      let pageStaus = this.$route.query.pageStaus;
      let currProductTypeId = this.$route.query.currProductTypeId;
      let index = this.$route.query.index;
      let levId = this.$route.query.levId;
      if (pageStaus == 1) {
        // 根据类型获取商品
        that.searchProductByType(index, currProductTypeId);
        // 产品类别点击
        that.openNextLevel(index, levId);
      } else {
        this.$parent.$refs.headerModular.searchKey = that.searchKey;
        //
        that.currProductTypeId = that.$route.query.type_id;
        // 产品列表
        that.getProductList(1);
      }
    },

    /**
     * 翻译
     */
    pageTranslate() {
      let that = this;
      let transformText = "";
      for (const key in that.pageText) {
        transformText += key + "=" + that.pageText[key] + "&";
      }
      that.languageTranslate(transformText);
    },

    /**
     * 语言翻译 - 单个词语
     * @param {*} text
     */
    languageTranslate(text) {
      let that = this;
      this.$parent.translate(
        text,
        (res) => {
          // 处理页面死数据
          that.processingResults(res.data);
        },
        (res) => {}
      );
    },
    /**
     * 处理返回的结果
     */
    processingResults(data) {
      let that = this;
      let textArr = data.split("&amp;");

      textArr.forEach((v, i) => {
        if (v != "") {
          // console.log('v-v',v.split('=')[0],v.split('=')[1]);
          for (const key in that.pageText) {
            if (v.split("=")[0] == key) {
              that.pageText[key] = v.split("=")[1];
            }
          }
        }
      });
    },
  },
  mounted() {
    let that = this;
    let url = window.location.href
    console.log("url",url)
    localStorage.setItem("url",url)
    // 当前语言
    that.currLanguage = localStorage.getItem("curLanguageType");
    // 搜索关键词
    that.searchKey = that.$route.query.searchKey;
    // 商品分类
    // that.getCategoryList();
    // 获取页面参数
    setTimeout(() => {
      that.getProductTypeByUrl();
    }, 300);
    // 翻译
    // that.pageTranslate();
  },
};
</script>

<style lang="scss" scoped>
.product-show-modular {
  .body-modular {
    .right-item-modualr {
      .commodity-show-modular {
        .commodity-show-item-modualr {
          // margin-right: 32px;
          margin-right: 15px;
          width: 19%;
        }
        .commodity-show-item-modualr:nth-child(5n){
          margin-right: 0;
        }
      }
    }
  }
}
@media screen and (max-width: 500px) {
  .product-show-modular {
  .body-modular {
    .right-item-modualr {
      .commodity-show-modular {
        .commodity-show-item-modualr {
          margin-right: 0;
        }
        // .commodity-show-item-modualr:nth-child(7n){
        //   margin-right: 0;
        // }
      }
    }
  }
}
}
</style>


// WEBPACK FOOTER //
// src/view/productShowByType.vue